import React, { HTMLAttributes } from "react";
import { onDesktop } from "@teamscheme/theme";
import styled from "styled-components";
import Card from "../../formatting/Card";
import { NokPrice } from "@teamscheme/nok-price";

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

const AllInOneIllustrationViewBoxWidth = "200px";
const ImageWrapper = styled.div`
  display: none;
  ${({ theme }) => onDesktop`
    flex-basis: 30%;
    align-items: center;
    display: flex;
    min-width: ${AllInOneIllustrationViewBoxWidth};
    margin-left: ${theme.spacing.space24};
  `}
`;

const AllInOne = styled(function (
  props: Omit<HTMLAttributes<HTMLDivElement>, "children">
) {
  return (
    <Card {...props}>
      <ContentWrapper>
        <div>
          <h2>Få alt-i-ett</h2>
          <p>
            Nå har vi samlet alt du trenger for handelen i én kontrakt. Når dere
            fyller ut kjøpekontrakten sammen kan både salgsmelding og
            omregistrering kobles til, og sendes rett til Statens vegvesen
            &ndash; helt automatisk!
          </p>
          <article>
            <section>
              <p>Oppgrader til Standard og få:</p>
              <ul>
                <li>Kjøpekontrakt </li>
                <li>Identifisering og signering med BankID</li>
                <li>Salgsmelding og omregistrering hos Statens vegvesen</li>
                <li>Forsikringstilbud*</li>
              </ul>
              <p>
                For NAF-medlemmer er Standard kjøpekontrakt inkludert i
                medlemskapet. Er du ikke NAF-medlem kan kontrakten oppgraderes
                for kun <NokPrice value={79} />.
              </p>
              <p>*Gjelder kun personbiler.</p>
            </section>
          </article>
        </div>
        <ImageWrapper>
          <img
            src="/graphics/illustrations/man_with_pc_and_coffee_landingpage.svg"
            alt="Alt-i-ett kjøpekontrakt"
          />
        </ImageWrapper>
      </ContentWrapper>
    </Card>
  );
})`
  position: relative;
  margin-bottom: 0;
  background: ${({ theme }) => theme.nafColor.signature.yellow20};

  h2 {
    margin-top: ${({ theme }) => theme.spacing.space12};
  }

  ${({ theme }) => onDesktop`
    margin: ${theme.spacing.space24} auto ${theme.spacing.space80};
    padding: ${theme.spacing.space48};

    h2 {
      margin-top: 0;
    }

    article {
      display: flex;

      p:last-child {
        margin-bottom: 0;
      }
    }

    section {
      flex: 1;
    }
  `}
`;

export default AllInOne;
